import { Controller } from "@hotwired/stimulus"

// Replica Chakra Accordion (collapsible, lazyMount, defaultValue=[0])
// Cada item tiene trigger + content. Click en trigger togglea el content.
export default class extends Controller {
  static targets = ["item", "trigger", "content", "indicator"]

  connect() {
    // Abrir el primer item por defecto (defaultValue=[0] en Chakra)
    this.contentTargets.forEach((content, index) => {
      if (content.dataset.defaultOpen === "true") {
        content.classList.remove("hidden")
        this._rotateIndicator(index, true)
      }
    })
  }

  toggle(event) {
    const trigger = event.currentTarget
    const item = trigger.closest("[data-manage--course-accordion-target='item']")
    const index = this.itemTargets.indexOf(item)
    if (index === -1) return

    const content = this.contentTargets[index]
    const isOpen = !content.classList.contains("hidden")

    content.classList.toggle("hidden")
    this._rotateIndicator(index, !isOpen)
  }

  // No-op: usado por el sortable-handle para detener propagación del click al toggle
  noop(event) {
    event.stopPropagation()
  }

  // Marca el post clickeado como activo en el sidebar y cierra modales
  selectPost(event) {
    this._clearActivePost()
    const link = event.currentTarget
    const container = link.closest("[data-course-post-container]") || link
    container.classList.add("bg-[#ebebeb]")
    this._closeModals()
  }

  // Admin: click en el div contenedor navega al post via Turbo.visit
  navigatePost(event) {
    const container = event.currentTarget
    const url = container.dataset.navigateUrl
    if (!url) return

    this._clearActivePost()
    container.classList.add("bg-[#ebebeb]")
    this._closeModals()

    const frame = container.dataset.turboFrame
    if (frame && frame !== "_top") {
      const frameEl = document.getElementById(frame)
      if (frameEl) {
        frameEl.src = url
        history.pushState({}, "", url)
        return
      }
    }
    Turbo.visit(url)
  }

  // Detiene propagación para que elementos internos (thumbnail, dropdown, drag) no disparen navigatePost
  stopEvent(event) {
    event.stopPropagation()
  }

  _clearActivePost() {
    this.element.querySelectorAll("[data-course-post-link]").forEach(el => {
      const container = el.closest("[data-course-post-container]") || el
      container.classList.remove("bg-[#ebebeb]")
    })
    // También limpiar containers admin que no tienen link interno
    this.element.querySelectorAll("[data-course-post-container]").forEach(el => {
      el.classList.remove("bg-[#ebebeb]")
    })
  }

  _closeModals() {
    document.querySelectorAll('[data-controller*="manage--modal"]').forEach(el => {
      const ctrl = window.Stimulus && window.Stimulus.getControllerForElementAndIdentifier(el, "manage--modal")
      if (ctrl && ctrl.panelTarget && ctrl.panelTarget.classList.contains("modal-panel--open")) {
        ctrl.close()
      }
    })
  }

  _rotateIndicator(index, open) {
    const indicator = this.indicatorTargets[index]
    if (!indicator) return

    if (open) {
      indicator.style.transform = "rotate(90deg)"
    } else {
      indicator.style.transform = "rotate(0deg)"
    }
  }
}
